import React from 'react';
import employeesData from '../../Pool/data'
import NewEmployeeForm from '../NewEmployyeForm/NewEmployeeForm'
import SalarySummarizing from "../SalarySummarizing/SalarySummarizing";
import Select from 'react-select'
import {salaryCompartmentsGenerator} from '../../functions'

class EmployeeTable extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            departmentsList: [],
            salaryCompartments: [],
            queryString: '',
            typingTimeout: 0,
            matchedEmployees: [],
            selectedDepartments: [],
            selectedSalary: '',
            flagToRefresh: false,
            showForm: false,
        };
    }

    componentDidMount = () => {
        const departments = new Set(employeesData.PRACOWNICY.map(employee => {
            return employee.dzial
        }));
        const fullDepartmentsList = Array.from(departments);
        const departmentsList = fullDepartmentsList.map(department => {
            return {value: department, label: department}
        });

        this.setState({
            departmentsList: departmentsList,
            salaryCompartments: salaryCompartmentsGenerator(employeesData.PRACOWNICY)
        });
    };

    componentDidUpdate(prevProps, prevState, snapshot) {
        const departments = new Set(employeesData.PRACOWNICY.map(employee => {
            return employee.dzial
        }));
        const fullDepartmentsList = Array.from(departments);
        const departmentsList = fullDepartmentsList.map(department => {
            return {value: department, label: department}
        });

        if (this.state.departmentsList.length < departmentsList.length) {

            this.setState({
                departmentsList: departmentsList
            });
        }
    }

    renderEmployeeData = () => {
        const dataBaseToRenderEmployees = this.state.queryString.length === 0 ? (this.state.matchedEmployees.length > 0 ? this.state.matchedEmployees : employeesData.PRACOWNICY) : this.state.matchedEmployees;

        return (
            dataBaseToRenderEmployees.map((employee, i) => {
                const {imie, nazwisko, dzial, wynagrodzenieKwota, wynagrodzenieWaluta} = employee;
                return (
                    <tbody key={i + imie + nazwisko}>
                    <tr>
                        <th scope="row">{++i}</th>
                        <td>{imie}</td>
                        <td>{nazwisko}</td>
                        <td>{dzial}</td>
                        <td>{wynagrodzenieKwota} {wynagrodzenieWaluta}</td>
                    </tr>
                    </tbody>
                )
            })
        )
    };

    handleEmployeesSearching = () => {
        let matchedEmployees = employeesData.PRACOWNICY;

        if (this.state.queryString !== '') {
            matchedEmployees = matchedEmployees.filter(matchedEmployee => {
                const {imie, nazwisko} = matchedEmployee;

                if (this.state.queryString.includes(' ')) {
                    // if there is space - split string
                    const splitted = this.state.queryString.toLowerCase().split(' ');

                    // if both are non empty string - do a strict check for name and last name
                    if (splitted[0] !== '' && splitted[1] !== '') {
                        return (imie.toLowerCase().includes(splitted[0]) && nazwisko.toLowerCase().includes(splitted[1])) ||
                            (imie.toLowerCase().includes(splitted[1]) && nazwisko.toLowerCase().includes(splitted[0]))
                    } else if (splitted[0] !== '') { // check if first part is not blank e.g " name/last name"

                        return imie.toLowerCase().includes(splitted[0]) || nazwisko.toLowerCase().includes(splitted[0]);
                    } else if (splitted[1] !== '') { // check if second part is not blank e.g "name/last name "

                        return imie.toLowerCase().includes(splitted[1]) || nazwisko.toLowerCase().includes(splitted[1]);
                    }
                }
                // if there is no space run normal check
                return imie.toLowerCase().includes(this.state.queryString.toLowerCase()) || nazwisko.toLowerCase().includes(this.state.queryString.toLowerCase());
            })
        }

        if (this.state.selectedDepartments && this.state.selectedDepartments.length > 0) {
            matchedEmployees = matchedEmployees.filter(matchedEmployee => {
                const {dzial} = matchedEmployee;
                return this.state.selectedDepartments.find(department => {
                    return department.value === dzial
                })
            })
        }

        if (this.state.selectedSalary !== '') {
            matchedEmployees = matchedEmployees.filter((employee) => {
                return employee.wynagrodzenieKwota <= this.state.selectedSalary
            }).filter(employee => {
                return +employee.wynagrodzenieKwota > +this.state.selectedSalary - 500
            });
        }

        if (matchedEmployees.length === 0) {
            alert('Żaden pracownik nie spełnia kryteriów wyszukiwania!');
            this.setState({
                queryString: '',
                matchedEmployees: [],
                selectedDepartments: [],
                selectedSalary: ''
            })
        }
        this.setState({
            matchedEmployees,
        })
    };

    clearSearching = () => {
        this.setState({
            queryString: '',
            matchedEmployees: [],
            selectedDepartments: [],
            selectedSalary: ''
        });
        let matchedEmployees = employeesData.PRACOWNICY;
    };

    selectDepartment = (e) => {
        this.setState({
            selectedDepartments: e,
        }, () => {
            this.handleEmployeesSearching()
        });
    };

    selectSalary = (e) => {
        this.setState({
            selectedSalary: e.value
        }, () => {
            this.handleEmployeesSearching()
        });
    };

    handleRefresh = () => {
        this.setState({
            flagToRefresh: !this.state.flagToRefresh,
            showForm: false,
            salaryCompartments: salaryCompartmentsGenerator(employeesData.PRACOWNICY)
        })
    };

    showNewEmployeeForm = () => {
        this.setState({
            showForm: true
        })
    };


    render() {
        return (
            <>
                <div className="input-group mb-3 px-3">
                    <input type="text" className="form-control" placeholder="Szukaj po imieniu lub nazwisku..."
                           aria-label="Recipient's username" aria-describedby="basic-addon2"
                           value={this.state.queryString} onChange={(e) => {
                        const queryString = e.target.value;

                        if (this.state.typingTimeout) {
                            clearTimeout(this.state.typingTimeout);
                        }
                        this.setState({
                            name: e.target.value,
                            typingTimeout: setTimeout(() => {
                                this.handleEmployeesSearching();
                            }, 1000),
                            queryString: queryString,
                        });
                    }}/>
                    <div className="input-group-append">
                        <button className="btn btn-outline-secondary" type="button"
                                onClick={this.clearSearching}>Wyczyść
                        </button>
                    </div>
                </div>
                <button type="button" className="btn btn-primary btn-lg btn-block"
                        onClick={this.showNewEmployeeForm}>Dodaj pracownika
                </button>
                {this.state.showForm &&
                <NewEmployeeForm changeRefreshFlag={this.handleRefresh} departmentsList={this.state.departmentsList}/>}
                <div className="table-responsive">
                    <table className="table general-color ">
                        <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Imię</th>
                            <th scope="col">Nazwisko</th>
                            <th scope="col">
                                <Select name='filters'
                                        options={this.state.departmentsList}
                                        placeholder="Dział"
                                        onChange={this.selectDepartment}
                                        isSearchable={false}
                                        value={this.state.selectedDepartments}
                                        isMulti
                                />
                            </th>
                            <th scope="col">
                                <Select
                                    options={this.state.salaryCompartments}
                                    placeholder="Wynagrodzenia"
                                    onChange={this.selectSalary}
                                    isSearchable={false}
                                    value={null}/>
                            </th>
                        </tr>
                        </thead>
                        {this.renderEmployeeData()}
                    </table>
                </div>
                <SalarySummarizing departments={this.state.departmentsList}/>
            </>
        )
    }

}

export default EmployeeTable